import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { Page } from '@frontend/vanilla/core';
import { Store } from '@ngrx/store';

import { LineSwitcherActions } from '../actions';
import { ILineSwitcherSwapButtonState } from '../state';

@Component({
    selector: 'bs-line-switcher-swap-button',
    templateUrl: './line-switcher-swap-button.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LineSwitcherSwapButtonComponent {
    @Input() event: EventModel;
    @Input() buttonState: ILineSwitcherSwapButtonState;
    @Input() hasError: boolean;

    constructor(
        public pageConfig: Page,
        private store: Store,
    ) {}

    onButtonClick(): void {
        this.store.dispatch(this.hasError ? LineSwitcherActions.closeLineSwitcher() : LineSwitcherActions.swapSportPick({ model: this.event }));
    }
}
